import { combineReducers } from 'redux';

import smartScoreReducer from 'views/EnergySmartScoreDashboard/reducers/EnergySmartScoreDashboardReducer';
import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import mapReducer from '../components/Map/reducers/MapReducer';
import mapCapacityReducer from '../components/MapCapacity/reducers/MapReducer';
import mapReducerGeneric from '../components/MapGeneric/reducers/MapReducerGeneric';
import mapCapacityReducerGeneric from '../components/MapCapacityGeneric/reducers/MapReducerGeneric';
import mapDriveTestsReducer from '../views/MapDriveTests/reducers/MapDriveTestsReducer';
import mapDriveTestsReducerGeneric from '../views/MapDriveTestsGeneric/reducers/MapDriveTestsReducerGeneric';
import datasetExportReducer from '../views/DatasetExport/reducers/DatasetExportReducer';
import STTMAlgorithmReducer from '../views/STTMAlgorithm/reducers/STTMAlgorithmReducer';
import STTMAlgorithmReducerGeneric from '../views/STTMAlgorithmGeneric/reducers/STTMAlgorithmReducerGeneric';
import dualMapReducer from '../views/DualMap/reducers/DualMapReducer';
import dualMapReducerGeneric from '../views/DualMapGeneric/reducers/DualMapReducerGeneric';

import homeReducer from '../views/Home/reducers/HomeReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	dashboardInspectReducer,
	mapReducer,
	mapCapacityReducer,
	mapReducerGeneric,
	mapCapacityReducerGeneric,
	mapDriveTestsReducer,
	mapDriveTestsReducerGeneric,
	datasetExportReducer,
	homeReducer,
	STTMAlgorithmReducer,
	STTMAlgorithmReducerGeneric,
	dualMapReducer,
	dualMapReducerGeneric,
	smartScoreReducer
});

export default rootReducer;
